// ============================================
// OFFICEFORGED — Module Navigation
// Handles switching between module views.
// Works with header dock + donut selector.
// ============================================

export class Sidebar {
  constructor(gridModule) {
    this.activeModule = 'home';
    this.gridModule = gridModule;
    this._initHomeActions();
    this._initGlobalButtons();
    this._initBrandHomeClick();
    this._loadHomeSavedSheets();
  }

  switchModule(module) {
    this.activeModule = module;

    // Hide all module views
    document.querySelectorAll('.module-view').forEach(el => {
      el.style.display = 'none';
    });

    // Show the selected module
    const moduleEl = document.getElementById(`module-${module}`);
    if (moduleEl) {
      moduleEl.style.display = 'flex';
    }

    // Update dock active state
    document.querySelectorAll('.dock-slot').forEach(btn => {
      btn.classList.toggle('dock-slot-active', btn.dataset.module === module);
    });

    // Initialize grid when first shown
    if (module === 'grid' && this.gridModule) {
      this.gridModule.show();
    }

    this._trackRecent(module);
  }

  _initBrandHomeClick() {
    // Clicking the OF logo goes home
    document.querySelectorAll('#header-brand, #header-brand-text').forEach(el => {
      el.addEventListener('click', () => this.switchModule('home'));
    });
  }

  _initGlobalButtons() {
    const newBtn = document.getElementById('global-new-btn');
    const saveBtn = document.getElementById('global-save-btn');

    if (newBtn) {
      newBtn.addEventListener('click', () => {
        if (this.activeModule === 'grid' && this.gridModule) {
          this.gridModule._newSpreadsheet();
        } else if (this.activeModule === 'docs') {
          // Docs new document
          const editor = window.OfficeForged?.editor;
          if (editor && editor.newDocument) editor.newDocument();
        } else {
          // Default: switch to docs
          this.switchModule('docs');
        }
      });
    }

    if (saveBtn) {
      saveBtn.addEventListener('click', () => {
        if (this.activeModule === 'grid' && this.gridModule) {
          this.gridModule._exportXLSX();
        } else if (this.activeModule === 'docs') {
          const editor = window.OfficeForged?.editor;
          if (editor && editor._saveToStorage) editor._saveToStorage();
        }
      });
    }
  }

  _initHomeActions() {
    document.querySelectorAll('.home-action').forEach(btn => {
      btn.addEventListener('click', () => {
        const action = btn.dataset.action;
        if (action === 'new-doc') {
          this.switchModule('docs');
        } else if (action === 'new-grid') {
          this.switchModule('grid');
          if (this.gridModule) this.gridModule.show();
        } else if (action === 'open-pdf') {
          this.switchModule('pdf');
        } else if (action === 'open-file') {
          this.switchModule('grid');
          if (this.gridModule) {
            this.gridModule.show();
            setTimeout(() => {
              const importBtn = document.getElementById('grid-import-xlsx');
              if (importBtn) importBtn.click();
            }, 300);
          }
        }
      });
      btn.addEventListener('mouseenter', () => { btn.style.background = '#f0f4ff'; btn.style.borderColor = '#2563eb'; });
      btn.addEventListener('mouseleave', () => { btn.style.background = '#fff'; btn.style.borderColor = '#e0e0e0'; });
    });
  }

  async _loadHomeSavedSheets() {
    if (!window.localforage) return;
    try {
      const index = await window.localforage.getItem('ofg_sheet_index') || [];
      const container = document.getElementById('home-saved-sheets');
      if (!container) return;
      if (index.length === 0) {
        container.innerHTML = '<div style="color:#aaa;font-style:italic;">No saved spreadsheets yet.</div>';
        return;
      }
      container.innerHTML = index.map(e => `
        <div class="home-sheet-item" data-key="${e.key}" style="display:flex;justify-content:space-between;align-items:center;padding:8px 10px;border-bottom:1px solid #f0f0f0;cursor:pointer;border-radius:6px;">
          <div>
            <div style="font-weight:600;color:#1a1a1a;">${e.title}</div>
            <div style="font-size:11px;color:#999;">${new Date(e.savedAt).toLocaleString()}</div>
          </div>
          <span style="color:#2563eb;font-size:12px;">Open &#8594;</span>
        </div>
      `).join('');

      container.querySelectorAll('.home-sheet-item').forEach(item => {
        item.addEventListener('mouseenter', () => { item.style.background = '#f0f7ff'; });
        item.addEventListener('mouseleave', () => { item.style.background = 'none'; });
        item.addEventListener('click', () => {
          this.switchModule('grid');
          if (this.gridModule) {
            this.gridModule.show();
            setTimeout(() => this.gridModule._loadLocal(), 300);
          }
        });
      });
    } catch (e) { /* ignore */ }
  }

  _trackRecent(module) {
    // Could be extended to track recent file activity
  }
}
